/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Level_ProbationInputs */



/**
* | output |
* | --- |
* | "Probation" |
*
* @param {Sanction_Level_ProbationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_level_probation = /** @type {((inputs?: Sanction_Level_ProbationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Level_ProbationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Probation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Libertad condicional")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Condicional")
	if (locale === "it") return /** @type {LocalizedString} */ ("Probation")
	return /** @type {LocalizedString} */ ("Probation")
});